/* BL4CKOUT: decorative videos (marked data-apx-lazy instead of autoplay) only download and play
   when they come near the screen, and pause when they leave it. Videos hidden by CSS (for example
   the desktop version on a phone) never download. Without JavaScript the poster image stays. */
(function () {
  if (window.__apxLazyVideo) return;
  window.__apxLazyVideo = true;
  function play(v) {
    if (!v.dataset.apxLazyStarted) { v.dataset.apxLazyStarted = '1'; v.preload = 'auto'; }
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) play(v);
      else if (v.dataset.apxLazyStarted && !v.paused) v.pause();
    });
  }, { rootMargin: '250px 0px' }) : null;
  function scan(root) {
    (root || document).querySelectorAll('video[data-apx-lazy]:not([data-apx-lazy-bound])').forEach(function (v) {
      v.setAttribute('data-apx-lazy-bound', '');
      if (io) io.observe(v); else play(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
